import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/button';
import { useQueryParams } from '../../../../hooks/useQueryParams';
import { sanitizeRedirectTo } from '../../../../utils/safeRedirect';

type Props = {
  providerId: string;
  providerName: string;
  headless?: boolean;
  className?: string;
};

const LoginWithSaml: React.FC<React.PropsWithChildren<Props>> = ({
  providerId,
  providerName,
  headless,
  className,
}) => {
  const { t } = useTranslation();
  const { redirectTo } = useQueryParams();
  return (
    <div className={className}>
      {!headless && (
        <>
          <h1 className="display-4 text-center mb-3">
            {t('signInSaml.title')}
          </h1>
          <p className="text-muted text-center mb-5">
            {t('signInSaml.subTitle', { provider: providerName })}
          </p>
        </>
      )}
      <Button
        className="w-100"
        label={t('signInSaml.button', { provider: providerName })}
        onClick={(e) => {
          e.preventDefault();
          const params = new URLSearchParams({ providerId });
          const safeRedirect = sanitizeRedirectTo(redirectTo);
          if (safeRedirect) {
            params.set('redirectTo', safeRedirect);
          }
          window.location.href = `/_auth/saml?${params.toString()}`;
        }}></Button>
    </div>
  );
};

export default LoginWithSaml;
